import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const SuccessIcon = ({ fill = 'green', size = 'large' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox={'0 0 32 32'}
        >
            <path
                className={fillStyles}
                d="M16,0 C7.16266667,0 0,7.16266667 0,16 C0,24.836 7.16266667,32 16,32 C24.836,32 32,24.836 32,16 C32,7.16266667 24.836,0 16,0 M16,1.33333333 C24.0866667,1.33333333 30.6666667,7.91333333 30.6666667,16 C30.6666667,24.0866667 24.0866667,30.6666667 16,30.6666667 C7.91333333,30.6666667 1.33333333,24.0866667 1.33333333,16 C1.33333333,7.91333333 7.91333333,1.33333333 16,1.33333333 Z M24.9037714,11.9900952 C25.2957714,11.6020952 25.2997714,10.9687619 24.9117714,10.5754286 C24.5251048,10.1820952 23.8904381,10.1807619 23.4957714,10.5674286 L12.9984381,20.9340952 L9.41977143,17.1767619 C9.0384381,16.7754286 8.4064381,16.7607619 8.00377143,17.1420952 C7.60377143,17.5234286 7.5904381,18.1567619 7.97177143,18.5554286 L12.9544381,23.7887619 L24.9037714,11.9900952 Z"
                fillRule="evenodd"
            />
        </svg>
    );
};
